import { render, staticRenderFns } from "./companyCenter.vue?vue&type=template&id=013c8298&scoped=true"
import script from "./companyCenter.vue?vue&type=script&lang=js"
export * from "./companyCenter.vue?vue&type=script&lang=js"
import style0 from "./companyCenter.vue?vue&type=style&index=0&id=013c8298&prod&lang=css"
import style1 from "./companyCenter.vue?vue&type=style&index=1&id=013c8298&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013c8298",
  null
  
)

export default component.exports